<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <wf-consumer-corp-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm"></wf-consumer-corp-form>
  </j-modal>
</template>

<script>

  import WfConsumerCorpForm from './WfConsumerCorpForm'
  export default {
    name: 'WfConsumerCorpModal',
    components: {
      WfConsumerCorpForm
    },
    data () {
      return {
        title: '',
        width: 1200,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })
      },
      edit (record, tab) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record, tab);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback () {
        this.$emit('ok');
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>
<style lang="less" scoped>
  /deep/ .ant-modal-body {
    padding: 12px !important;
    max-height: none !important;
  }

  /deep/ .ant-form-item {
    margin-bottom: 3px;
  }
</style>